import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import TablePagination from "@material-ui/core/TablePagination";
import {TableFooter} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {Print} from "@material-ui/icons";
import ReactToPrint from "react-to-print";
import {DateTime} from "luxon/build/es6/luxon";
import moment from "moment";

const useRowStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    print:{
        display: "none",
    },
    noPrint: {
        display: "block"
    },
    ordenTitle:{
        textAlign: "center",
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(5)
    },
    heightFull:{
      height: "100%"
    },
    [`@media print`]: {
        print: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            display: "block"
        },
        noPrint: {
            display: "none"
        }
    }
}));

// function Row(props) {
const Row = React.forwardRef((props, ref) => {

    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    // var time = Date.now()

    return (
        <React.Fragment ref={ref}>
            <div className={`${classes.print}`} ref={ref}>
                <br/>
                <br/>
                <p><strong>Nuevo pedido via Kulko.App</strong></p>
                <br/>
                {row.products.map((prod, index) => (
                    <p><strong>{prod.quantity}x {prod.name} - </strong>${parseInt(prod.price) * parseInt(prod.quantity)}</p>
                ))}
                <br/>
                <p><strong>Total: </strong>${row.total}</p>
                <p><strong>Tipo de entrega: </strong>{row.type}</p>
                <br/>
                <p><strong>Fecha del pedido: </strong>{row.createdAt}</p>
                <p><strong>Fecha de entrega: </strong>{moment().format("DD-MMM-YY hh:mm:ss")}</p>
            </div>

            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>
                    <ReactToPrint
                        trigger={() =>
                            <Button
                                fullWidth={true}
                                // variant="contained"
                                color="primary"
                                // className={classes.button}
                                // disabled={!formIsValid || loading}
                                startIcon={<Print/>}
                                size={"large"}
                            >

                            </Button>}
                        content={() => ref.current}
                    />
                </TableCell>
                <TableCell component="th" scope="row">
                   <strong>#{row.orderNumber}</strong>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.createdAt}
                </TableCell>
                <TableCell align="right">{row.type}</TableCell>
                <TableCell align="right">{row.client}</TableCell>
                <TableCell align="right">{row.contact}</TableCell>
                <TableCell align="right">{row.total}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Pedido
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {/*<TableCell/>*/}
                                        <TableCell><strong>Producto</strong></TableCell>
                                        <TableCell align="right"><strong>Cantidad</strong></TableCell>
                                        <TableCell align="right"><strong>Total ($)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.products.map((prod, index) =>(
                                        <TableRow key={index}>
                                            {/*<TableCell/>*/}
                                            <TableCell component="th" scope="row">
                                                {prod.name}
                                            </TableCell>
                                            <TableCell align="right">{prod.quantity}</TableCell>
                                            <TableCell align="right">
                                                {parseInt(prod.price) * parseInt(prod.quantity)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableFooter>

                                </TableFooter>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </React.Fragment>
    );
});

Row.propTypes = {
    row: PropTypes.shape({
        calories: PropTypes.number.isRequired,
        carbs: PropTypes.number.isRequired,
        fat: PropTypes.number.isRequired,
        history: PropTypes.arrayOf(
            PropTypes.shape({
                amount: PropTypes.number.isRequired,
                total: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            }),
        ).isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired
    }).isRequired,
};

export default function CollapsibleTable(props) {
    const {orders} = props;
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    let  componentRef  =  useRef([]) ;
    componentRef.current = orders.map(
        (ref, index) =>   componentRef.current[index] = React.createRef()
    )
    const [componentToPrint,setComponentToPrint] = React.useState();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell/>
                            <TableCell/>
                            <TableCell>Código pedido</TableCell>
                            <TableCell>Fecha</TableCell>
                            <TableCell align="right">Tipo de entrega</TableCell>
                            <TableCell align="right">Cliente</TableCell>
                            <TableCell align="right">Contacto</TableCell>
                            <TableCell align="right">Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            orders
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                        <>
                                            <Row ref={componentRef.current[index]} key={index} row={row}/>
                                            {/*<ReactToPrint*/}
                                            {/*    trigger={() =>*/}
                                            {/*        <Button*/}
                                            {/*            fullWidth={true}*/}
                                            {/*            variant="contained"*/}
                                            {/*            color="primary"*/}
                                            {/*            // className={classes.button}*/}
                                            {/*            // disabled={!formIsValid || loading}*/}
                                            {/*            startIcon={<Print/>}*/}
                                            {/*            // size={"large"}*/}
                                            {/*        >*/}
                                            {/*            IMPRIMIR*/}
                                            {/*        </Button>}*/}
                                            {/*    content={() => componentRef.current[index].current}*/}
                                            {/*/>*/}
                                        </>
                                    )
                                )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={orders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </>
    );
}
